'use client'

import { motion } from 'framer-motion'

const steps = [
  {
    number: '01',
    title: 'Signal',
    description:
      'A voice call, a tap in the app, or an API event enters the system. Any channel, any language.',
    example: 'Tenant taps "Book EV charger" → intent logged with full context',
  },
  {
    number: '02',
    title: 'Orchestrate',
    description:
      'The engine routes, cross-references live data, and makes a decision in milliseconds — without human intervention.',
    example:
      'System checks availability, pricing rules, and access permissions in 40ms',
  },
  {
    number: '03',
    title: 'Act',
    description:
      'A gate opens. A vehicle dispatches. A ticket issues. A tenant gets their ride. Physical reality changes.',
    example:
      'Charger unlocked → confirmation sent → revenue logged → data feeds pricing model',
  },
]

export function ProductDemoSection() {
  return (
    <section className="py-24 bg-[#0d1117]" id="how-it-works">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-xs font-mono tracking-widest text-[#00c8ff] uppercase mb-4">
            How It Works
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#e2e8f0] tracking-tight">
            End-to-End Orchestration
          </h2>
          <p className="mt-4 text-[#94a3b8] max-w-xl mx-auto text-lg">
            From intent to physical action — automated.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative">
          {/* Connector line (desktop only) */}
          <div className="hidden md:block absolute top-10 left-[16.66%] right-[16.66%] h-px bg-gradient-to-r from-transparent via-[#1c2333] to-transparent" />

          {steps.map((step, i) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              className="relative flex flex-col items-center text-center p-8 rounded-xl border border-[#1c2333] bg-[#07090f]"
            >
              <span className="text-5xl font-bold text-[#00c8ff] font-mono mb-6 leading-none">
                {step.number}
              </span>
              <h3 className="text-xl font-semibold text-[#e2e8f0] mb-3">
                {step.title}
              </h3>
              <p className="text-base text-[#94a3b8] leading-relaxed mb-4">
                {step.description}
              </p>
              <p className="text-sm font-mono bg-[#0d1117] border border-[#1c2333] rounded px-3 py-2 w-full text-left text-[#94a3b8]">
                {step.example}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
